/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceName } from './ServiceName';
import {
    ServiceNameFromJSON,
    ServiceNameFromJSONTyped,
    ServiceNameToJSON,
} from './ServiceName';

/**
 * 
 * @export
 * @interface BackOfficeApiKeyCreateRequest
 */
export interface BackOfficeApiKeyCreateRequest {
    /**
     * 
     * @type {ServiceName}
     * @memberof BackOfficeApiKeyCreateRequest
     */
    service: ServiceName;
    /**
     * 
     * @type {Array<string>}
     * @memberof BackOfficeApiKeyCreateRequest
     */
    scopes: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeApiKeyCreateRequest
     */
    description: string;
}



/**
 * Check if a given object implements the BackOfficeApiKeyCreateRequest interface.
 */
export function instanceOfBackOfficeApiKeyCreateRequest(value: object): value is BackOfficeApiKeyCreateRequest {
    if (!('service' in value) || value['service'] === undefined) return false;
    if (!('scopes' in value) || value['scopes'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function BackOfficeApiKeyCreateRequestFromJSON(json: any): BackOfficeApiKeyCreateRequest {
    return BackOfficeApiKeyCreateRequestFromJSONTyped(json, false);
}

export function BackOfficeApiKeyCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackOfficeApiKeyCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'service': ServiceNameFromJSON(json['service']),
        'scopes': json['scopes'],
        'description': json['description'],
    };
}

export function BackOfficeApiKeyCreateRequestToJSON(value?: BackOfficeApiKeyCreateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'service': ServiceNameToJSON(value['service']),
        'scopes': value['scopes'],
        'description': value['description'],
    };
}

